import React, { useState } from 'react';
import { Card } from '@citrus/card';
import { List } from '@citrus/list';
import NoResult from './questionChartsNoResult';
import {
  Table,
  TableRow,
  Tbody,
  Td,
  Tr,
  Th,
  Thead,
} from '@citrus/data-table';
import { ZeroState } from '@citrus/zero-state';


const MultiLineChart = ({ questionData, number, isSummary }) => {

  const [expandedValues, setExpandedValues] = useState([]);
  const tableConfig = {
    page: 1,
    size: Number.MAX_SAFE_INTEGER,
    sorting: {
      column: '',
      direction: '',
      sort: ''
    }
  }

  const onClickToggleExpandableRow = value => {
    if (expandedValues.indexOf(value) >= 0) {
      setExpandedValues(expandedValues.filter(x => x !== value));
      return;
    }
  
    setExpandedValues([ ...expandedValues, value]);
  };
  
  const renderExpanded = (groupData, groupNumber) => {
    return (
      <Table.Core
        automationId={`expanded-multi-line-response-${groupNumber}-table`}
        itemCount={groupData.responses.length}
        onChangePage={() => {}}
        page={tableConfig.page}
        pageSize={tableConfig.size}
        css={"div > div > div > span { display: none }"}
        renderZeroState={() => <ZeroState type="insufficientdata" />}
      >
        <Thead>
          <Th column="participant">Participant</Th>
          <Th column="answer">Answer</Th>
        </Thead>
        <Tbody>
          {groupData.responses.map((response, index) => {
            return (
              <Tr key={`expanded-multi-line-response-${groupNumber}-table-response-${index}`}>
                <Td>{response.employeeName}</Td>
                <Td>{response.response}</Td>
              </Tr>
            )})
          }
        </Tbody>
      </Table.Core>
    )
  }
  
  const renderRow = (groupData, index) => {
    return (
      <TableRow.Expandable
        expanded={expandedValues.indexOf(groupData.value) >= 0}
        id={groupData.value}
        key={groupData.value}
        onClick={() => onClickToggleExpandableRow(groupData.value)}
        render={() => (
          <Tr key={`expandable-multi-line-row-${index}`}>
            <Td>{groupData.text}</Td>
            <Td css={'width: auto; white-space:nowrap; span { float: right; }'}>
              <span>{groupData.responses.length}</span>
            </Td>
          </Tr>
        )}
      >
        {renderExpanded(groupData, index)}
      </TableRow.Expandable>
    );
  }

  if(questionData === null || typeof(questionData) !== typeof([]) || questionData.length === 0) {
    return (<NoResult number={number}/>);
  }  

  if(isSummary) {
    return (
      <Card automationId={"question-" + number + "-multiLine-card"}>
        <List.Core 
          data={questionData} 
          automationId={"question-" + number + "-multiLine-list"} 
          primarykey={"question-" + number + "-list"}>
        {
          questionData.map((groupData, index) => {
            return (
              <List.Group 
                collapsible={false} 
                title={groupData.text} 
                automationId={"question-" + number + "-multiLine-group"} 
                key={index}> 
              { 
                groupData.responses.map((response,index) => {
                  return (
                    <List.Item automationId={"question-" + number + "-multiLine-item"} key={index}>
                      {response.response}
                    </List.Item>
                  );
                })
              }
              </List.Group>
            );
          })
        }
        </List.Core>
      </Card>
    );
  }

  return (
    <Table.Core
      automationId={"question-" + number + "-multiline-chart"}
      itemCount={questionData.length}
      onChangePage={() => {}}
      page={tableConfig.page}
      pageSize={tableConfig.size}
      css={"div > div > div > span { display: none }"}
      renderZeroState={() => <ZeroState type="insufficientdata" />}
    >
      <Thead>
        <Th column="text">Items</Th>
        <Th column="count" css={'width: auto; white-space:nowrap; span { float: right; }'}>Total Answers</Th>
      </Thead>
      <Tbody>
        {questionData.map((groupData, index) => renderRow(groupData, index))}
      </Tbody>
    </Table.Core>
  );
}

export default MultiLineChart;